import styled from 'styled-components';

export const Container = styled.div`
    color: #fff;
    display: none;
    padding-left: 8px;
    padding-right: 8px;

    @media (min-width: 992px) {
        display: block;
        padding-left: 16px;
    }

    @media (min-width: 1200px) {
        padding-right: 40px;
    }
`;
